export const GROOV_ICON_LOGO = "GroovIconLogo";
